import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type { TimesheetPageEmployeesSettingFragment } from 'generated/resources/graphql'

import type ShiftVersionHistory from 'modules/attendance/store/models/ShiftVersionHistory'

import Description from './Description'

interface ItemProps {
  history: ShiftVersionHistory
  attendanceSetting?: TimesheetPageEmployeesSettingFragment
}

const Item = ({ history, attendanceSetting }: ItemProps) => {
  const historyType = (type: string) => {
    switch (type) {
      case 'clocked_in':
        return i18n.t('clock_in.history.types.clocked_in')
      case 'clocked_out':
        return i18n.t('clock_in.history.types.clocked_out')
      case 'created':
        return i18n.t('clock_in.history.types.created')
      case 'updated':
        return i18n.t('clock_in.history.types.updated')
      case 'observation_updated':
        return i18n.t('clock_in.history.observation_title')
      case 'location_type_updated':
        return i18n.t('clock_in.history.location_type_title')
      default:
        return ''
    }
  }

  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal color="grey000White" weight="semibold">
          {historyType(history.type)}
        </Text.Normal>
      </Box>
      <Description history={history} attendanceSetting={attendanceSetting} />
      <Box flexDirection="row" justifyContent="flexStart" gap="s4">
        <Text size="100" color="lighter920">
          {history.createdAt.format('L, HH:mm')}
        </Text>
        {history.hasBrowserPlatformName && (
          <>
            <Text size="100" color="lighter920">
              ·
            </Text>
            <Text size="100" color="lighter920">
              {history.browserPlatformName}
            </Text>
          </>
        )}
      </Box>
    </Box>
  )
}

export default observer(Item)
